import React, { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

interface IMessageModalProps {
  isOpen: boolean;
  type: 'error' | 'success' | 'info';
  content?: React.ReactNode;
  onClose?: () => void;
  title?: string;
  children?: React.ReactNode;
  actionButtons?: React.ReactNode;
}

const ModalOverlay = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled(Box)`
  border-radius: 8px;
  padding: 24px;
  width: 30%;
  max-width: 900px;
  max-height: 30vh;
  overflow: auto;
  position: relative;
  background-color: white;
  outline: none;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
`;

const ModalBody = styled(Box)`
  position: relative;
  min-height: 150px;
`;

const LoadingWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const MessageModal: React.FC<IMessageModalProps> = ({
  isOpen,
  type,
  content,
  onClose,
  title,
  children,
  actionButtons,
}) => {
  return (
    <ModalOverlay
      open={isOpen}
      onClose={onClose}
      aria-labelledby='message-modal-title'
      aria-describedby='message-modal-description'
    >
      <ModalContent>
        <CloseButton aria-label='close' onClick={onClose}>
          <CloseIcon />
        </CloseButton>

        <ModalBody>
          {title && (
            <Typography
              id='message-modal-title'
              variant='h6'
              component='h2'
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 2,
                fontWeight: 'bold',
              }}
            >
              {title}
            </Typography>
          )}

          <Typography id='message-modal-description' variant='body1'>
            {content}
            {children}
          </Typography>
        </ModalBody>

        <DialogActions>{actionButtons && actionButtons}</DialogActions>
      </ModalContent>
    </ModalOverlay>
  );
};
